import { ChangeDetectionStrategy, Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { NotificationType } from '@core';
import { NotificationService } from './../../../core/components/notification/notification.service';
import { catchError, EMPTY } from 'rxjs';
import { SafeHtml } from '@angular/platform-browser';
import { CookieboxService } from '../../cookiebox.service';
import { CookieboxContentContainerComponent } from '../cookiebox-content-container/cookiebox-content-container.component';

@Component({
    selector: 'app-general-privacy-statement',
    templateUrl: './general-privacy-statement.component.html',
    imports: [CookieboxContentContainerComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneralPrivacyStatementComponent implements OnInit {
    protected privacyStatementHtml: WritableSignal<SafeHtml> = signal('<p>wird geladen...</p>');

    private cookieboxService = inject(CookieboxService);
    private notificationService = inject(NotificationService);

    public ngOnInit(): void {
        this.cookieboxService
            .fetch(environment.generalPrivacyStatementUrl)
            .pipe(
                catchError(() => {
                    this.notificationService.notify(
                        'Datenschutzerklärung konnte nicht geladen werden.',
                        NotificationType.CRITICAL,
                    );
                    return EMPTY;
                }),
            )
            .subscribe((html: SafeHtml) => this.privacyStatementHtml.set(html));
    }
}
